import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import Panel from '../../elements/Panel/Panel';

const ConnectionsHeader: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Panel p={2}>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Typography color='primary.main' variant='h6' component='h4'>
          Login Options
        </Typography>
      </Box>
      <Box color='text.primary'>
        <Typography variant='body1' sx={{ wordBreak: 'break-word' }}>
          Manage your OX Security login options. Please select how you want
          members of your organization to login to OX Security.
        </Typography>
      </Box>
    </Panel>
  );
};

export default ConnectionsHeader;
